<template>
  <div class="main">
    <div v-if="showLoading" class="loading-container">
      <van-loading type="spinner" size="24px" />
    </div>
  </div>
</template>

<script>
import { getWxCode } from '../api/index'
import { errMsg } from '../utils/business'

export default {
  name: 'LoginCallback',

  data () {
    return {
      showLoading: true
    }
  },

  mounted () {
    let params = undefined
    params = this.getUrlParams()
    // 把code传给接口
    this.showLoading = true
    getWxCode(params).then(res => {
      this.showLoading = false
      if (res.code === 0) {
        const code = res.data || '12345'
        // 跳转到企微页面
        window.location.href = `wxworklocal://onlogin?code=${code}`
      } else {
        errMsg(res.msg)
      }
    }).catch((error) => {
      this.showLoading = false
    })
  },
  methods: {
    getUrlParams () {
      // search只能在取到"?"后面和"#"之前的内容，如果"#"之前没有"?"，search取值为空
      let urlParams = ''
      const search = decodeURI(location.search)
      const hash = decodeURI(location.hash)
      if (search) {
        urlParams = search.substr(1) || ''
      } else if (hash && hash.indexOf('?') > 0) {
        urlParams = hash.split('?')[1] || ''
      }
      // key: value
      const theRequest = new Object()
      let strs = urlParams.split('&')
      for (let i = 0; i < strs.length; i++) {
        const item = strs[i].split('=')
        if (item[0]) {
          theRequest[item[0]] = item[1] || ''
        }
      }

      return theRequest
    },
  }
}
</script>

<style scoped>
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background-color: hsla(0,0%,100%,.9);
  }
</style>